// oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
import { AnnotationInfoIcon } from '@latitude/icons';
import { Text } from '@latitude/text';
import { Tooltip } from '@latitude/tooltip';

type Props = {
  note: string;
};

export const QuestionNote = ({ note }: Props) => (
  <Tooltip
    text="Anchorage Digital has added specific guidance for this question to help you provide the most relevant information"
    side="bottom"
    align="start"
  >
    <div
      className="flex items-center gap-1"
      data-testid="question-note"
      tabIndex={0}
    >
      <AnnotationInfoIcon className="shrink-0" />
      <Text color="muted" variant="captionMedium">
        {note}
      </Text>
    </div>
  </Tooltip>
);
